import { ButtonProps, ButtonType, ButtonWidget, Img, InteractionState } from '@tableau/widgets';
import React from 'react';

import { imgPath } from '~src/commonInfra/utils/ImgUrl';

import { Messages } from '../../../codegen/Localize';
import { PageHeaderStyles } from '../layout/PageHeaderStyles';

import cssVar = PageHeaderStyles.CssVariables.cssVar;
import CssVariables = PageHeaderStyles.CssVariables;

const DEFAULT_ICON_PATH = imgPath('spaces_header_device_preview_regular.svg');

function getPreviewButtonContent(displayOnlyIcons: boolean): ((state: InteractionState) => JSX.Element) {
  return (state: InteractionState): JSX.Element => {
    const buttonText = Messages.previewDeviceLayouts();

    const iconSize = cssVar(CssVariables.headerIconSize);

    const iconStyle = displayOnlyIcons? PageHeaderStyles.iconOnlyButton : PageHeaderStyles.iconForTextButton;

    const imgProps: React.ImgHTMLAttributes<HTMLImageElement> = {
      draggable: false,
      height: iconSize,
      width: iconSize,
      src: DEFAULT_ICON_PATH, // from the design the icon is the same for hover and regular states
      style: iconStyle
    };

    const backgroundColor = {backgroundColor: (state.hover ? cssVar(CssVariables.headerBackgroundHoverColor) : 'transparent')};

    return (
      <div className={PageHeaderStyles.TextButton} style={backgroundColor}>
        <Img {...imgProps} alt=""/>
        {!displayOnlyIcons && buttonText }
      </div>
    );
  };
}

export function DevicePreviewButton(props: DevicePreviewButton.Props):
  React.ReactElement<DevicePreviewButton.Props> {
    const { handleClick, displayOnlyIcons } = props;

    const buttonStyle = {
      display: 'inline-block',
      cursor: 'pointer'
    };

    const testId = 'toggle-device-preview-mode';

    const iconButtonProps: ButtonProps = {
      buttonType: ButtonType.IconOutline,
      getContent: getPreviewButtonContent(displayOnlyIcons),
      testId: testId,
      handleClick: handleClick,
      style: buttonStyle,
      title: Messages.deviceLayoutsTooltip()
    };

    return (
      <ButtonWidget {...iconButtonProps} />
    );
  }

export namespace DevicePreviewButton {
  export interface Props {
    readonly handleClick: () => void;
    readonly displayOnlyIcons: boolean;
  }
}
